module.exports = "/images/not-maintenance-history.svg?1cbe9261dda526db26544e334e881ae2";